<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { Link } from '@inertiajs/vue3';

const show = ref(true);
const props = defineProps({ notification: Object, showCallback: Function });

defineExpose({ show });

function setRead() {
    //do axios call to set notification to read
    axios.post('/portal/notificaties/' + props.notification.id + '/read').then(response => {
        show.value = false;
        props.showCallback();
    })
}

</script>

<template>
    <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div v-if="show" class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <font-awesome-icon :icon="['far', 'inbox']" class="text-gray-400 h-5 w-5 shrink-0"/>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900">{{notification.title}}</p>
                <p class="mt-1 text-sm text-gray-500">{{ notification.body }}</p>
                <div class="mt-3 flex space-x-7" v-if="notification.type == 'bid' || notification.type == 'lot'">
                  <Link @click="setRead" :href="'/portal/kavel/'+notification.data.lot_id" type="button" class="rounded-md bg-white text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Naar kavel</Link>
                </div>
              </div>
              <div class="ml-4 flex flex-shrink-0">
                  <button type="button" @click="setRead" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                  <span class="sr-only">Sluiten</span>
                  <font-awesome-icon :icon="['far', 'xmark']" class="text-black h-5 w-5 pt-2 shrink-0"/>
                </button>
              </div>
            </div>
          </div>
        </div>
    </transition>
</template>